module.exports = __webpack_public_path__ + "img/hero-top.239dc60c.png";